/**
 * 出货订单管理- 下载loading
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 */
import React from 'react';
import Lang from "@components/Lang/Lang";
import ShipperManagementAction from "../ShipperManagement.action";
import {Result, message, Spin} from "antd";
import qs from 'qs'

class DownLoading extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            iId: '',
            model:{},
            sUrl:'',
            downloadType:'',
            orderTypeList:'',
            lang:''
        }
    }
    /**
     * 查看详情
     * */
    getDetail(sId='',sType='',downloadType,orderTypeList,lang){



            const postData = {
                containerId:sId,
            }


            if(sType === 'OrderMsg'){
                postData.downloadType = downloadType;
                postData.lang = lang;
            }
 
            ShipperManagementAction.getDownloadPic(postData,sType).then(res=>this.handleRes(res.data,sId,sType)).catch(err=>this.handleRes(err,sId,sType));
    }
    handleRes(res={},sId='',sType=''){
        const {success,valid,model} = res;
        let {downloadType,orderTypeList,lang} = this.state;
        if(success&&valid){
            if(model&&model.viewName){
                this.setState({
                    sUrl: model.viewName,
                    loading:false
                })
                window.location.href = model.viewName
                // window.open(model.viewName.'');


                // setTimeout(()=>{
                //     this.loading(false);
                //     window.close()
                // },5000)

            }else{
                setTimeout(()=>{
                    this.getDetail(sId,sType,downloadType,orderTypeList,lang)
                },3000)
            }
        }else if(res.message)message.warning(res.message);
    }
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    getCerId(str){
        str = str.length>0?str.substr(1,str.length):'';
        const data =  qs.parse(str); 
        this.setState({
            iId: data.id,
            sType : data.type,
            downloadType:data.downloadType,
            orderTypeList:data.orderTypeList,
            lang:data.lang,
        })

        this.getDetail(data.id,data.type,data.downloadType,data.orderTypeList,data.lang);
    }
    componentWillMount() {
        const { search } = this.props.location;
        const sId = this.getCerId(search);
    }
    componentWillUnmount(){
    }
    render(){
        const { loading,model,sUrl, } = this.state;
        return (<Spin tip={Lang({default:'请等待，文件正在打包中',id:'QingDengDaiWenJianZhengZaiDaBaoZhong'})} spinning={loading} size="large">
            <div style={{width:'100%',minHeight: '320px', textAlign:'center', }}>
                {/* 请等待，文件正在打包中 */}

                {!loading&& <Result
                    status="success"
                    extra={[
                        <a className={'ant-btn'} href={sUrl} target={'_self'} style={{ borderRadius: '4px'}}>{Lang({id: "XiaZai",default: "下载"})}</a>,
                    ]}
                />
               }
            </div>
        </Spin>)}
}

export default DownLoading